import {
  PageSelectedPacksData,
  QuantityBySize,
} from '../../../services/modules/product-colors-packs/product-colors-packs.types';
import { OfflineDatabasePack } from '../database/offlineDatabase/types/offlineDatabasePack.types';
import { OfflineProductColorPack } from '../database/offlineDatabase/types/offlineDatabaseProductColor.types';
import { OfflineDatabaseSize } from '../database/offlineDatabase/types/offlineDatabaseSize.types';

interface ToPageSelectedPacksDataParams {
  offlinePack: OfflineDatabasePack;
  offlineSizes: OfflineDatabaseSize[];
  offlineProductColorPack: OfflineProductColorPack;
}

export class OfflinePacksTransformers {
  static toPageSelectedPacksData({
    offlinePack,
    offlineSizes,
    offlineProductColorPack,
  }: ToPageSelectedPacksDataParams): PageSelectedPacksData {
    const quantitiesBySize: QuantityBySize[] = offlinePack.quantitiesBySize.map(
      (quantityBySize) => ({
        id: quantityBySize.id,
        quantity: quantityBySize.quantity,
        size: offlineSizes.find((size) => size.id === quantityBySize.sizeId)!,
      }),
    );

    const orderedQuantities = quantitiesBySize.sort((a, b) => a.size.position - b.size.position);

    return {
      id: offlinePack.id,
      name: offlinePack.name,
      quantitiesBySize: orderedQuantities,
      willConsumeStock: offlineProductColorPack.willConsumeStock,
      stock: {
        reservedAmount: 0,
        totalAmount: offlineProductColorPack.stock.totalAmount,
        availableAmount: offlineProductColorPack.stock.availableAmount,
      },
    };
  }
}
